import authGuard from './auth.guard';
import * as constants from '../constants';

const nms = [ constants.NAMESPACE, 'router' ].join('/');
const log = require('debug')('@mycure/vue-plugins/' + nms);

/**
 * @typedef {import('./auth.guard').GuardOpts} RouterOpts
 */

export default {
  /**
   * @param {import('vue').Component} Vue
   * @param {RouterOpts} opts
   */
  install (Vue, opts) {
    log('installing with opts', opts);
    Vue.use(authGuard, opts);
  }
};
